<script setup lang="ts">
</script>

<template>
  <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M14 2H6a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z" />
    <polyline points="14 2 14 7 19 7" />
    <line x1="16" y1="12" x2="8" y2="12" />
    <line x1="16" y1="16" x2="8" y2="16" />
    <line x1="10" y1="8" x2="8" y2="8" />
  </svg>
</template>